import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52623bb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex accordian" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { key: 4 }
const _hoisted_8 = { key: 5 }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = ["innerHTML", "title"]
const _hoisted_13 = ["innerHTML", "title"]
const _hoisted_14 = { key: 4 }
const _hoisted_15 = { key: 5 }
const _hoisted_16 = { key: 6 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectItem = _resolveComponent("SelectItem")!
  const _component_Accordion = _resolveComponent("Accordion")!
  const _component_Badge = _resolveComponent("Badge")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Accordion, null, {
      button: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("shared.search-and-filter")), 1)
      ]),
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_SelectItem, {
            id: "coordinator",
            value: _ctx.selectedCoordinator.id,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedCoordinator.id) = $event)),
            name: _ctx.selectedCoordinator.name,
            "onUpdate:name": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedCoordinator.name) = $event)),
            onSelectionChanged: _ctx.onCoordinatorChange,
            options: _ctx.coordinators,
            placeholder: `- ${_ctx.$t('shared.choose')} -`,
            placeholderValue: "0",
            enableReset: true,
            label: _ctx.$t('shared.coordinator')
          }, null, 8, ["value", "name", "onSelectionChanged", "options", "placeholder", "label"])
        ])
      ]),
      _: 1
    }),
    _hoisted_2,
    _createVNode(_component_Table, {
      rows: _ctx.rows,
      sortColumn: _ctx.sortColumn,
      "onUpdate:sortColumn": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.sortColumn) = $event)),
      ascending: _ctx.ascending,
      "onUpdate:ascending": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.ascending) = $event)),
      stickyFirstColumn: "",
      showPagination: "",
      allowChangeRowPerPage: "",
      showNumRows: "",
      pagingData: _ctx.pagingData,
      hiddenColumns: _ctx.hiddenColumns,
      unsortableColumns: _ctx.unsortableColumns,
      pageHeading: _ctx.pageHeading,
      useSpinner: true,
      isLoading: _ctx.isLoading,
      onPageNumberChanged: _ctx.onPageNumberChange,
      onSortChanged: _ctx.onSortChange,
      onPageSizeChanged: _ctx.onPageSizeChange
    }, {
      td: _withCtx((data) => [
        (data.col === 'coordinatorName')
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$t("shared.coordinator")), 1))
          : (data.col === 'proposedNoteTakersCount')
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$t("shared.proposedNoteTakersCount")), 1))
            : (data.col === 'offer')
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t("shared.offer")), 1))
              : (data.col === 'titleSv' || data.col === 'titleEn')
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t("course-occurrence.title")), 1))
                : (data.col === 'latestNoteTakerOffer')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.$t("course-occurrence.offer.offer")), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t(`course-occurrence.${data.col}`)), 1))
      ]),
      default: _withCtx((data) => [
        (data.col === 'status')
          ? (_openBlock(), _createBlock(_component_Tooltip, {
              key: 0,
              text: _ctx.statusText(data.val),
              bgColor: _ctx.statusBgColor(data.val),
              color: _ctx.statusTextColor(data.val)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Badge, {
                  rounded: true,
                  backgroundColor: _ctx.statusBgColor(data.val)
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 2
                }, 1032, ["backgroundColor"])
              ]),
              _: 2
            }, 1032, ["text", "bgColor", "color"]))
          : (data.col === 'occurrence')
            ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                (
              _ctx.currentUser.checkEntitlement([
                [
                  'Anteckningsstödsadministratör',
                  'or',
                  'Anteckningsadministratör',
                ],
                'or',
                'Samordnare',
              ])
            )
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: _ctx.navigateToDetailsUrl + data.row.id
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.replaceUnvailableOrFormatDate(data.val)), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.replaceUnvailableOrFormatDate(data.val)), 1))
              ]))
            : _createCommentVNode("", true),
        (this.$i18n.locale === 'en' && data.col === 'titleEn')
          ? (_openBlock(), _createElementBlock("span", {
              key: 2,
              innerHTML: 
            _ctx.truncate(
              _ctx.replaceUnvailableOrFormatDate(data.val),
              _ctx.courseTitleTruncationLength
            )
          ,
              title: data.val.length > _ctx.courseTitleTruncationLength ? data.val : ''
            }, null, 8, _hoisted_12))
          : _createCommentVNode("", true),
        (this.$i18n.locale === 'sv' && data.col === 'titleSv')
          ? (_openBlock(), _createElementBlock("span", {
              key: 3,
              innerHTML: 
            _ctx.truncate(
              _ctx.replaceUnvailableOrFormatDate(data.val),
              _ctx.courseTitleTruncationLength
            )
          ,
              title: data.val.length > _ctx.courseTitleTruncationLength ? data.val : ''
            }, null, 8, _hoisted_13))
          : (data.col === 'offer')
            ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.getLatestCourseInstanceOfferDate(data.val)), 1))
            : (
            data.col === 'courseStartDate' || data.col === 'courseEndDate'
          )
              ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.replaceUnvailableOrFormatDate(data.val)), 1))
              : (
            data.col !== 'occurrence' &&
            data.col !== 'titleEn' &&
            data.col !== 'titleSv' &&
            data.col !== 'status' &&
            data.col !== 'offer' &&
            data.col !== 'courseStartDate' &&
            data.col !== 'courseEndDate'
          )
                ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(data.val), 1))
                : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["rows", "sortColumn", "ascending", "pagingData", "hiddenColumns", "unsortableColumns", "pageHeading", "isLoading", "onPageNumberChanged", "onSortChanged", "onPageSizeChanged"])
  ]))
}